import React from 'react';
import Navbar from '../Shared/Navbar';
import { useParams } from 'react-router-dom';
import './CandidateProfile.css';

function CandidateProfile({ user, onLogout }) {
  const { id } = useParams();

  // Mock candidate data
  const candidate = {
    id,
    name: 'Sarah Chen',
    title: 'Senior Fashion Designer',
    location: 'New York, NY',
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'sarah.chen@example.com',
    portfolio: {
      style: ['minimalist', 'contemporary'],
      materials: ['silk', 'linen', 'sustainable fabrics'],
      specialties: ['womenswear', 'eveningwear'],
      projectCount: 24
    },
    projects: [
      {
        id: 1,
        name: 'SS24 Minimalist Collection',
        description: 'A sustainable collection focusing on clean lines and natural fabrics',
        images: ['https://via.placeholder.com/400x500', 'https://via.placeholder.com/400x500']
      },
      {
        id: 2,
        name: 'Evening Wear Capsule',
        description: 'Elegant pieces for special occasions',
        images: ['https://via.placeholder.com/400x500', 'https://via.placeholder.com/400x500']
      }
    ],
    experience: [
      { company: 'Calvin Klein', role: 'Senior Designer', years: '2020-2023' },
      { company: 'Theory', role: 'Associate Designer', years: '2018-2020' }
    ]
  };

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="recruiter" />
      
      <div className="profile-container">
        <div className="profile-layout">
          {/* Left Sidebar */}
          <div className="profile-sidebar">
            <div className="card">
              <div className="profile-image-wrapper">
                <img src={candidate.profileImage} alt={candidate.name} className="profile-image" />
              </div>
              <h2>{candidate.name}</h2>
              <p className="profile-title">{candidate.title}</p>
              <p className="profile-location">📍 {candidate.location}</p>
              
              <div className="profile-actions">
                <button className="btn btn-primary btn-block">+ Add to Pipeline</button>
                <button className="btn btn-secondary btn-block">📧 Contact</button>
              </div>
            </div>

            <div className="card" style={{ marginTop: '1rem' }}>
              <h3>Specialties</h3>
              <div className="tag-list">
                {candidate.portfolio.specialties.map((spec, idx) => (
                  <span key={idx} className="badge badge-info">{spec}</span>
                ))}
              </div>
            </div>

            <div className="card" style={{ marginTop: '1rem' }}>
              <h3>Materials</h3>
              <div className="tag-list">
                {candidate.portfolio.materials.map((mat, idx) => (
                  <span key={idx} className="badge badge-success">{mat}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="profile-content">
            <div className="card">
              <h2>Portfolio</h2>
              <p className="text-gray-600">{candidate.portfolio.projectCount} projects</p>
              
              <div className="projects-list">
                {candidate.projects.map(project => (
                  <div key={project.id} className="project-item">
                    <div className="project-images">
                      {project.images.map((img, idx) => (
                        <img key={idx} src={img} alt={`${project.name} ${idx + 1}`} />
                      ))}
                    </div>
                    <div className="project-details">
                      <h3>{project.name}</h3>
                      <p>{project.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="card" style={{ marginTop: '1.5rem' }}>
              <h2>Experience</h2>
              <div className="experience-list">
                {candidate.experience.map((exp, idx) => (
                  <div key={idx} className="experience-item">
                    <div className="experience-icon">🏢</div>
                    <div>
                      <h4>{exp.role}</h4>
                      <p>{exp.company}</p>
                      <span className="text-sm text-gray-600">{exp.years}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidateProfile;
